import { NavLink, useLocation } from 'react-router-dom';
import { renderIcon } from '../common/Medias';
import { i18n } from '../lang/i18n';
import { useAppSelector } from '../store/hooks';


export default function NavigationMenu() {
    const cart = useAppSelector((state) => state.cart)
    const userData = useAppSelector((state) => state.userData)
    const location = useLocation();
    const orders = userData.orders
    const paths = location.pathname.split('/');
    return <nav className="navbar">
        <ul>
            <li className={(paths.length < 2 || paths[1] === '')?"select":""}>
                <NavLink to="/" className="menu-link">
                    {renderIcon('navigation-home')}
                    <div className="menu-title">{i18n.NavigationMenu.Home}</div>
                </NavLink>
            </li>
            {(orders.length === 0 || cart.products.length > 0) && <li className={paths[1]==='cart'?"select":""}>
                <NavLink to="/cart" className="menu-link">
                    {renderIcon('navigation-cart')}
                    {cart.products.length === 0 && <div className="menu-title">{i18n.NavigationMenu.Cart}</div>}
                    {cart.products.length > 0 && <div className="menu-title"><span className="cart-number">{cart.products.length}</span></div>}
                </NavLink>
            </li>}
            {orders.length > 0 && <li className={paths[1]==='user_orders'?"select":""}>
                <NavLink to="/user_orders" className="menu-link">
                    {renderIcon('navigation-delivery')}
                    <div className="menu-title-highlight">{i18n.NavigationMenu.Orders}</div>
                </NavLink>
            </li>}
            <li className={paths[1]==='user'?"select":""}>
                <NavLink to="/user" className="menu-link">
                    {renderIcon('navigation-user')}
                    <div className="menu-title">{i18n.NavigationMenu.User}</div>
                </NavLink>
            </li>
            <li className={paths[1]==='locations'?"select":""}>
                <NavLink to="/locations" className="menu-link">
                    {renderIcon('navigation-locations')}
                    <div className="menu-title">{i18n.NavigationMenu.Address}</div>
                </NavLink>
            </li>
            <li className={paths[1]==='options'?"select":""}>
                <NavLink to="/options" className="menu-link">
                {renderIcon('navigation-options')}
                <div className="menu-title">{i18n.NavigationMenu.Options}</div>
                </NavLink>
            </li>
        </ul>
    </nav>
}